/* =========================================================================
   MARKETING Hero — Video Studio: shared types & constants.
   ========================================================================= */

export const VIDEO_DURATIONS = ["15 วิ", "30 วิ", "45 วิ", "60 วิ", "90 วิ", "3 นาที", "Long Form"];
export const VIDEO_TYPES = ["Ads", "Education", "Review", "Storytelling", "Talking Head", "Case Study", "Sales", "Retargeting", "Trust", "Authority"];
export const VIDEO_PLATFORMS = ["TikTok", "Reels/IG", "YouTube", "Facebook", "YouTube Shorts"];

export interface VideoInputs {
  topic?: string; duration?: string; type?: string; platform?: string;
  product?: string; pain?: string; desire?: string; name?: string;
}

export interface VideoScene { time: string; visual: string; onScreenText: string; voiceOver: string; }

export interface VideoOutput {
  idea: string;
  hook3s: string;
  hookVariations: string[];
  script: string;
  scenes: VideoScene[];
  shotList: string[];
  bRoll: string[];
  cta: string;
  thumbnail: string;
  caption: string;
  videoAiPrompt: string;
  platformAdaptation: string;
  disclaimer?: string;
}

export const VIDEO_SCHEMA_HINT = {
  idea: "string", hook3s: "string — hook 1-3 วิแรก", hookVariations: ["string"],
  script: "string — สคริปต์เต็ม", scenes: [{ time: "string เช่น 0-3s", visual: "string", onScreenText: "string", voiceOver: "string" }],
  shotList: ["string"], bRoll: ["string"], cta: "string", thumbnail: "string — ไอเดีย thumbnail",
  caption: "string", videoAiPrompt: "string", platformAdaptation: "string",
};
